import {ExtraOptions, PreloadAllModules, RouterModule, Routes} from '@angular/router';
import { NgModule } from '@angular/core';
import {AuthGuard} from 'app/auth-guard.service';
import {AuthComponent} from './auth/auth.component';
import {NotFoundComponent} from './shared/components/not-found/not-found.component';

const routes: Routes = [
  // { path: 'pages', loadChildren: 'app/pages/pages.module#PagesModule' },
  // { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: 'app/pages/pages.module#PagesModule' },
  { path: 'auth',
    loadChildren: 'app/auth/auth.module#AuthModule' },
  { path: '**', component: NotFoundComponent },
  // {
  //   path: 'auth',
  //   component: AuthComponent,
  //   children: [
  //     // ...
  //   ],
  // },
];

const config: ExtraOptions = {
  useHash: true,
  preloadingStrategy: PreloadAllModules,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  declarations: [],
})

export class AppRoutingModule {
}
